/* global Vimeo */
// In the markup, add an additional class called "vimeo" on div.video-play so that the below only targets vimeo and not youtube etc.
( function ( $ ) {
	$( document ).ready( function () {
		// In the markup, put a data attribute called data-vimeo on the thumbnail divs. set the attribute to the vimeo id. Then the below will add a bg image
		window.NFLVimeoThumbnail = function ( oembed ){
			$( 'div.vimeo.video-play[data-vimeo="' + encodeURIComponent( oembed.video_id ) + '"]' ).css( 'background-image', 'url(' + oembed.thumbnail_url + ')' );
		};

		$( 'div.vimeo.video-play' ).each(function () {
			var $thumb = $( this );
			var videoid = $thumb.data( 'vimeo' );
			var url = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + encodeURIComponent( videoid ) + '&callback=NFLVimeoThumbnail';
			var js = document.createElement( 'script' );
			js.setAttribute( 'type', 'text/javascript' );
			js.setAttribute( 'src', url );
			document.getElementsByTagName( 'head' ).item( 0 ).appendChild( js );
		} );

		var $vimeoIFrames = $( '[data-vimeo-iframe]' );

		if ( $vimeoIFrames && $vimeoIFrames.length ) {
			var tag = document.createElement( 'script' );
			tag.src = 'https://player.vimeo.com/api/player.js';
			var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
			firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );
		}

		var vimeoInterval = setInterval(
			function() {
				if ( typeof Vimeo !== 'undefined' ) {
					clearInterval( vimeoInterval );
					$vimeoIFrames.each( function () {
						var $videoIFrame = $( this );
						var vimeoPlayer = new Vimeo.Player( this );
						vimeoPlayer.on( 'play', function() {
							$videoIFrame.trigger( 'videohit.played' );
						} );
					} );
				}
			},
			250
		);

	} );
} )( jQuery );